<template>
  <!-- footer -->
  <div>
    <div class="public_footer bg_000000 hidden-xs hidden-sm hidden-md">
      <!-- medium  -->
      <div class="footer_medium p_flex p_column p_align_items">
        <img class="footer_logo" :src="require('@/assets/images/footer/footer_logo.png')" alt="" />
        <div class="medium_group p_flex">
          <div v-for="(item, idx) in medium_list" :key="idx" @click="goto_meiti(item.href)"
            class="medium_item p_hand p_flex p_align_items p_justify_center">
            <img class="medium_item_img1" :src="item.img1" alt="" />
            <img class="medium_item_img2" :src="item.img2" alt="" />
          </div>
        </div>
      </div>
      <!-- link -->
      <div class="footer_link p_flex p_column p_align_items">
        <div class="footer_link_group p_flex">
          <div @click="link_click('aboutUs','aboutUs')" class="footer_link_item animate__bounceInDown color_ffffff p_hand">
            {{ $t('footer.aboutus') }}</div>
          <div @click="link_click('aboutUs','contactus')" class="footer_link_item color_ffffff p_hand">{{ $t('footer.business') }}</div>
          <!-- 中文模式下展示 -->
          <div v-if="GET_LANG === 'zh'" @click="$router.push('/afterSales')" class="footer_link_item color_ffffff p_hand">{{ $t('footer.aftersales') }}</div>
          <div v-if="GET_LANG === 'zh'" @click="$router.push('/agreement')" class="footer_link_item color_ffffff p_hand">{{ $t('footer.agreement') }}</div>
          <div @click="is_checklang = !is_checklang"
            class="footer_link_item check_lang p_flex p_align_items color_ffffff p_hand">
            {{ $t('footer.language') }}
            <img class="footer_check" src="@/assets/images/footer/footer_check.png" alt="" />
            <transition name="el-fade-in">
              <div v-show="is_checklang" class="check_lang_box p_text_center">
                <div v-if="GET_LANG !== 'zh'" @click.capture="check_lang('zh')" :class="ischeck_zh ? '' : 'p_no_click'"
                  class="check_lang_item color_000000 font_15 font_800">简体中文</div>
                <div v-if="GET_LANG !== 'en'" @click.capture="check_lang('en')"
                  class="check_lang_item color_000000 font_15 font_800">English</div>
                <div v-if="GET_LANG !== 'ja'" @click.capture="check_lang('ja')"
                  class="check_lang_item color_000000 font_15 font_800">日本語</div>
              </div>
            </transition>
          </div>
        </div>
        <!-- number -->
        <div style="margin-top: 60px;" class="p_flex p_align_items">
          <img class="footer_check" src="https://wozhike-1306886396.cos.ap-nanjing.myqcloud.com/www/img/footer/beian_logo.png" alt="" />
          <a style="padding: 0 20px 0 10px;" class="footer_number" href="https://beian.mps.gov.cn/#/query/webSearch?code=41019602002523" rel="noreferrer" target="_blank">豫公网安备41019602002523号</a>
          <a target="_blank" href="https://beian.miit.gov.cn/" class="footer_number">豫ICP备2021030013号</a>
        </div>


      </div>
    </div>
    <!-- h5 -->
    <div class="public_footer_h5 bg_000000 hidden-lg">
      <div class="medium_h52 p_flex p_column p_align_items">
        <img class="footer_logo_h52" :src="require('@/assets/images/footer/footer_logo.png')" alt="" />
        <div class="link_group_h52 p_flex1 p_flex">
          <div @click="click_meiti(item.img2)" v-for="(item, idx) in medium_list" :key="idx"
            class="link_btn_h52 p_flex p_justify_center p_align_items p_hand">
            <img class="medium_img_h52" :src="item.img1" alt="" />
          </div>
        </div>
      </div>
      <!-- tk -->
      <public-popup :show='medium_img!==""' @callback="medium_img=''">
        <img v-if="medium_img" style="width: 280px;height: 280px;" :src="medium_img" alt="">
      </public-popup>
      <!--  -->
      <div style="border-top: solid 1px rgba(255, 255, 255, .3);"></div>
      <div class="footer_link_h5 p_flex p_column p_align_items">
        <div class="footer_link_group_h5 p_hand">
          <div @click="link_click('aboutUs','aboutUs')" class="link_item_h5 color_ffffff p_text_center">{{ $t('footer.aboutus') }}</div>
          <div @click="link_click('aboutUs','contactus')" class="link_item_h5 color_ffffff p_text_center">{{ $t('footer.business') }}</div>
          <!-- 中文模式下展示 -->
          <div v-if="GET_LANG === 'zh'" @click="$router.push('/afterSales')" class="link_item_h5 color_ffffff p_text_center">{{ $t('footer.aftersales') }}</div>
          <div v-if="GET_LANG === 'zh'" @click="$router.push('/agreement')" class="link_item_h5 color_ffffff p_text_center">{{ $t('footer.agreement') }}</div>
          <div @click="is_checklang = !is_checklang"
            class="link_item_h5 check_lang_h5 p_flex p_align_items p_justify_center color_ffffff">
            {{ $t('footer.language') }}
            <img class="footer_check" src="@/assets/images/footer/footer_check.png" alt="" />
            <transition name="el-fade-in">
              <div v-show="is_checklang" class="check_lang_box_h5 p_text_center">
                <div v-if="GET_LANG !== 'zh'" @click.capture="check_lang('zh')" :class="ischeck_zh ? '' : 'p_no_click'"
                  class="check_lang_item color_000000 font_15 font_800">
                  简体中文
                </div>
                <div v-if="GET_LANG !== 'en'" @click.capture="check_lang('en')"
                  class="check_lang_item color_000000 font_15 font_800">English</div>
                <div v-if="GET_LANG !== 'ja'" @click.capture="check_lang('ja')"
                  class="check_lang_item color_000000 font_15 font_800">日本語</div>
              </div>
            </transition>
          </div>
        </div>
        <!-- number -->
        <!-- <div class="footer_number_h5 p_text_center">Copyright © 2023 Snail Shell. All Rights Reserved.</div> -->
        <a class="footer_number_h5" href="https://beian.mps.gov.cn/#/query/webSearch?code=41019602002523" rel="noreferrer" target="_blank">豫公网安备41019602002523号</a>
        <a style="padding-top: 20px;" target="_blank" href="https://beian.miit.gov.cn/" class="footer_number_h5">豫ICP备2021030013号</a>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import {
    get_common_content
  } from '@/network/index.js';
  import {
    set_timeStorage,
    get_timeStorage
  } from '@/utils/utils.js';
  export default {
    data() {
      return {
        medium_img: '',
        medium_list: [{
            img1: require('@/assets/images/footer/medium_logo1.png'),
            img2: require('@/assets/images/footer/mtjz01.png'),
            href: 'https://twitter.com/wozhike'
          },
          {
            img1: require('@/assets/images/footer/medium_logo2.png'),
            img2: require('@/assets/images/footer/mtjz02.png'),
            href: 'https://weibo.com/z3xiaozuo'
          },
          {
            img1: require('@/assets/images/footer/medium_logo3.png'),
            img2: require('@/assets/images/footer/mtjz03.png'),
            href: ''
          },
          {
            img1: require('@/assets/images/footer/medium_logo4.png'),
            img2: require('@/assets/images/footer/mtjz04.png'),
            href: 'https://space.bilibili.com/27797856'
          },
          {
            img1: require('@/assets/images/footer/medium_logo5.png'),
            img2: require('@/assets/images/footer/mtjz05.png'),
            href: 'https://www.xiaohongshu.com/user/profile/5fec5c2b000000000101da57'
          }
        ],
        is_checklang: false
      };
    },
    created() {
      // this.get_common_api()
    },
    computed: {
      ...mapGetters('setting', ['GET_SCREEN', 'GET_LANG']),
      ischeck_zh() {
        if (this.$route.name === 'userEdit' || this.$route.name === 'userCenter' || this.$route.name === 'login') {
          return false;
        }
        return true;
      }
    },
    methods: {
      ...mapMutations('setting', ['SET_LANG']),
      check_lang(cont) {
        this.SET_LANG(cont);
      },
      //获取通用内容api
      // get_common_api() {
      //   get_common_content({
      //     name: '媒体迅雷,媒体微博,媒体微信,媒体b站,媒体小红书'
      //   }).then((res) => {
      //     console.log(res)
      //   })
      // },
      //媒体点击
      click_meiti(url) {
        this.medium_img = url
      },
      goto_meiti(href) {
        window.open(href, '_blank');
      },
      link_click(link,params) {
        this.$router.replace({
          name: link,
          params: {
            id: params
          }
        })
      }
    }
  };
</script>

<style scoped="scoped">
  .public_footer {
    width: 100vw;
    min-height: 850px;
    overflow-x: hidden;
  }

  /* medium */
  .footer_medium {
    box-sizing: border-box;
    height: 570px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding-top: 120px;
  }

  .footer_logo {
    width: 150px;
    height: 150px;
  }

  .medium_group {
    height: 180px;
    margin-top: 60px;
  }

  .medium_item {
    position: relative;
    width: 180px;
    height: 180px;
  }

  .medium_item:hover>.medium_item_img2 {
    opacity: 1;
    transform: rotateX(0deg);
    transition: all .5s;
    -o-transition: all 5s;
    -moz-transition: all .5s;
  }

  .medium_item_img1 {
    width: 60px;
    height: 60px;
  }

  .medium_item_img2 {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 180px;
    transform: rotateX(-90deg);
    transition: all .5s;
    -o-transition: all 5s;
    -moz-transition: all .5s;
  }

  .footer_link {
    padding-top: 90px;
  }

  .footer_link_item {
    font-size: 15px;
    font-weight: 800;
    padding: 0 30px;
  }

  .check_lang {
    position: relative;
  }

  .check_lang_h5 {
    position: relative;
  }

  .check_lang_box {
    width: 120px;
    min-height: 45px;
    position: absolute;
    bottom: 30px;
    left: 10px;
    z-index: 990;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 6px;
  }

  .check_lang_box_h5 {
    width: 120px;
    min-height: 45px;
    position: absolute;
    bottom: 40px;
    left: 50%;
    z-index: 990;
    transform: translateX(-50%);
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 6px;
  }

  .check_lang_box>.check_lang_item:first-child {
    border-bottom: solid 1px #d5d5d5;
    border-radius: 6px 6px 0 0;
  }

  .check_lang_box_h5>.check_lang_item:first-child {
    border-bottom: solid 1px #d5d5d5;
  }

  .check_lang_item {
    height: 45px;
    line-height: 45px;
  }

  .check_lang_item:hover {
    background-color: #d5d5d5;
    border-radius: 6px;
  }

  .footer_check {
    width: 15px;
    height: 15px;
    margin-left: 10px;
  }

  .footer_number {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
  }

  /* h52 */
  .medium_h52 {
    box-sizing: border-box;
    /* height: 540px; */
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding-top: 60px;
  }

  .footer_logo_h52 {
    width: 120px;
    height: 120px;
  }

  .link_group_h52 {
    padding: 60px 0;
  }

  .link_btn_h52 {
    width: 51px;
    height: 51px;
    line-height: 51px;
    border-radius: 3px 3px 3px 3px;
    opacity: 1;
    /* border: 1px solid #ffffff; */
    color: #ffffff;
    font-weight: 800;
    font-size: 12px;
    margin-bottom: 15px;
  }

  .medium_img_h52 {
    width: 36px;
    height: 36px;
    margin-right: 5px;
  }

  /*  */
  .footer_link_h5 {
    padding: 50px 0;
  }

  .footer_link_group_h5 {
    padding-bottom: 60px;
  }

  .link_item_h5 {
    padding: 10px 0;
  }

  .footer_number_h5 {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/public-footer/public-footer.vue